import { Button, Image, Toast } from "react-bootstrap";
import React, { useState } from "react";
import "../../../styles/containers/NonPayPeriodContainer.scss";
import SearchFilterNonPayPeriod from "../../../components/NonPayPeriodReportComponent/SearchFilterNonPayPeriod";
import NonPayPeriodReportIcon from "../../../assets/NonPayPeriodReportLogo.svg";
import GenerateReportTableNonPayPeriod from "../../../components/NonPayPeriodReportComponent/GenerateReportTableNonPayPeriod";
import NonPayPeriodReportSlideOut from "../../../components/NonPayPeriodReportComponent/NonPayPeriodReportSlideOut";
import { SliderPanel } from "../../../components";
import { useDeepEffect } from "../../../abstracts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { faTimes } from "@fortawesome/pro-light-svg-icons";

const NonPayPeriodReport = () => {
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [filterValues, setFilterValues] = useState({});
  const [gridData, setGridData] = useState([]);
  const [payload, setPayload] = useState({});
  const [ToastData, setToastData] = useState(false);
  const [planYear, setPlanYear] = useState([]);
  const [planList, setPlanList] = useState([]);
  const [sourceList, setSourceList] = useState([]);

  const SetPlanListDetails = (planYear, planList, sourceList) => {
    setPlanList(planList);
    setSourceList(sourceList);
    setPlanYear(planYear);
  };

  useDeepEffect(() => {
    const currentDate = new Date();
    setPayload((prevPayload) => ({
      ...prevPayload,
      companyId: filterValues.companyId,
      planId: filterValues.planId,
      allocationSourceId: filterValues.allocationSourceId,
      planYear: filterValues.planYear,
      getenerationFromDate:
        filterValues.dateRange?.fromDate ??
        new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
      generationToDate:
        filterValues.dateRange?.toDate ??
        new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0),
      from: 0,
      order: 1,
      offset: 20,
    }));
  }, [filterValues]);

  return (
    <div>
      <div className="d-flex justify-content-between mt-3 align-items-center">
        <h4 className="mt-3">Non Pay Period Report</h4>
        <Button
          type="secondary"
          className="mt-0"
          onClick={() => {
            setIsSliderOpen(true);
          }}
          size="md"
        >
          Generate Report
        </Button>
      </div>
      <div className="horizontal-nPayPeriod" />

      <SearchFilterNonPayPeriod
        filterValues={filterValues}
        setGridData={setGridData}
        gridData={gridData}
        setFilterValues={setFilterValues}
        setToastData={setToastData}
        sourceList1={sourceList}
        planList1={planList}
        planYear1={planYear}
      />

      {gridData?.length == 0 ? (
        <div className="d-flex flex-column align-items-center">
          <Image
            src={NonPayPeriodReportIcon}
            style={{ height: "250px", width: "250px" }}
          />
          <h6>No records found!</h6>
        </div>
      ) : (
        <GenerateReportTableNonPayPeriod
          payload={payload}
          gridData={gridData}
          setGridData={setGridData}
          setPayload={setPayload}
          isSliderOpen={isSliderOpen}
        />
      )}

      <div className="nonPayPeriodSlider">
        <SliderPanel isOpen={isSliderOpen} showCancel={false} size={60}>
          <NonPayPeriodReportSlideOut
            isSliderOpen={isSliderOpen}
            setSliderOpen={setIsSliderOpen}
            setFilterValues={setFilterValues}
            setGridData={setGridData}
            payload={payload}
            setToastData={setToastData}
            SetPlanListDetails={SetPlanListDetails}
          />
        </SliderPanel>
      </div>

      <Toast
        onClose={() => setToastData(false)}
        show={ToastData}
        className="toastNonPayPeriod"
        delay={8000}
        autohide
      >
        <Toast.Body className="success-toast-align">
          <div className="mr-3 mb-20">
            <FontAwesomeIcon icon={faCheckCircle} color="#3BB54A" size="md" />
          </div>
          <div className="">
            <p className="fs-12 fw-600">
              Non pay period report is being generated
            </p>
            <p className="sub-header-npay">
              You can download the report once the generation is complete
            </p>
          </div>
          <div className="mb-20">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000000"
              size="md"
              onClick={() => setToastData(false)}
            />
          </div>
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default NonPayPeriodReport;
